///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../collections/report-product-category.collection.ts"/>


module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;

    export class ReportProductCategoriesDataTemplate extends DataTemplateBase implements IDataTemplate {

        protected productCategories: ReportProductCategoryCollection;

        public title: string;
        public allSelectedLabel: string;

        get collection() {
            return this.productCategories;
        }

        constructor(model: Dictionary<any>, properties: string[], options: any) {
            super(model, properties, options);

            this.productCategories = new ReportProductCategoryCollection(this.model[properties[0]], [], {
                criteria: options.criteria,
                hiddenValue: options.hiddenValue,
                smartMoverHidden: () => this.smartMoverHidden
            });
            this.title = 'LABEL_PRODUCT_CATEGORY';
            this.allSelectedLabel = 'LABEL_ALL_PRODUCT_CATEGORIES';
            this.totalSelectedMessage = 'LABEL_TOTAL_PRODUCT_CATEGORIES_SELECTED';
        }
    }
}